import { axios, Response } from '../index'
import { Therapist } from './get-clinic-therapists'

export default async function therapistPendingInvite(): Response<Therapist[]> {
  return await axios.get(`/v1/therapists/invite`)
}
